import { pxToRem } from './util';

const typography = {
    paragraph: {
        marginBottom: pxToRem(14),
    },
};

export default typography;
